export default "__VITE_ASSET__GrxkXUp0__"